import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import { Table } from '../../../../common/table'
import { RULES_TYPE } from '../../../common/constant'
import { selectProfileById } from '../../store/slice'
import { SCORE_RULES_COL } from '../constant'
import classes from '../index.module.scss'
import { selectDataTable, selectIdsTable } from '../store/slice'
import { CreditRiskCondition } from './CreditRiskCondition'
import { CreditRiskThreshold } from './CreditRiskThreshold'
import { EmailCell } from './EmailCell'
import { NameScore } from './NameScore'
import { SwitchCell } from './SwitchCell'

export const ScoreRules = ({ isCreate = false }) => {
  const [search] = useSearchParams()

  const id = search.get('profileId')
  const ids = useSelector(selectIdsTable([RULES_TYPE.SCORE_RULES]))
  const data = useSelector(selectDataTable(ids[0]))
  const isDefaultProfile = useSelector(
    selectProfileById(+id, 'isDefaultProfile'),
  )

  const getSchema = () => {
    return Object.keys(SCORE_RULES_COL).map((key) => {
      const title = `alertSetting.${key}`
      const colId = SCORE_RULES_COL[key]
      const thStyle = {
        justifyContent: [SCORE_RULES_COL.SEND_EMAILS].includes(colId)
          ? 'center'
          : '',
      }
      const tdStyle = {
        width:
          colId === SCORE_RULES_COL.SWITCH
            ? 40
            : colId === SCORE_RULES_COL.SEND_EMAILS
            ? '25%'
            : colId === SCORE_RULES_COL.SCORE
            ? '33%'
            : '',
        position: 'relative',
      }

      return {
        colId,
        title,
        isI18n: true,
        thStyle,
        tdStyle,
        renderTh: (title) => {
          switch (colId) {
            case SCORE_RULES_COL.SWITCH:
              return ''
            default:
              return title
          }
        },
        render: (_, { rowId }) => {
          switch (colId) {
            case SCORE_RULES_COL.SWITCH:
              return <SwitchCell rowId={rowId} isCreate={isCreate} />
            case SCORE_RULES_COL.SCORE:
              return <NameScore rowId={rowId} />
            case SCORE_RULES_COL.CONDITION:
              return (
                <CreditRiskCondition
                  isDefaultProfile={isCreate ? false : isDefaultProfile}
                  rowId={rowId}
                />
              )
            case SCORE_RULES_COL.THRESHOLD:
              return (
                <CreditRiskThreshold
                  isDefaultProfile={isCreate ? false : isDefaultProfile}
                  rowId={rowId}
                />
              )
            case SCORE_RULES_COL.SEND_EMAILS:
              return <EmailCell rowId={rowId} />
            default:
              return ''
          }
        },
      }
    })
  }

  return (
    <Panel label={data?.groupName}>
      <Element style={{ backgroundColor: '#FFFFFF' }}>
        <Element
          className={classes.note}
          style={{ color: '#3A414B', borderBottomColor: '#B5CEF8' }}
        >
          <Translate value="alertSetting.SCORE_RULES_NOTE" />
        </Element>
        <Table ids={ids} schema={getSchema()} autoHeightMax={600} />
      </Element>
    </Panel>
  )
}
